import { useContext, useEffect, useState } from "react";

import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { ChannelState, SKChannel, Tier } from "../../../models/SKChannel";
import ImageInput from "../../artifacts/create/ImageInput";
import VideoInput from "../../artifacts/create/VideoInput";
import { FolderName } from "../../../api/shared/uploadService";
import { AddTextField } from "../../../components/AddTextField";

interface PublishingTiersProps {
  index: number;
  disabled?: boolean;
  channelData: SKChannel;
  updateChannelData?: React.Dispatch<React.SetStateAction<SKChannel | undefined>>;
}

export const ChannelSubscriptionIds = ({ index, disabled = false, channelData, updateChannelData }: PublishingTiersProps) => {
  //  const { channelData, updateChannelData, originalState } = useContext(CreateChannelContext);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  //const [editable, setEditable] = useState<boolean>(true);
  interface SubscritionType {
    text: string;
    note: string;
    type?: Tier | undefined;
  }
  const data: SubscritionType[] = [
    { text: "Free Only", type: Tier.free, note: "All content on this channel will be available for free." },
    { text: "Subscription Only", type: Tier.paid, note: "Only paid subscribers will be able to access your content." },
    { text: "Free and Subscription Both", type: Tier.freeNpaid, note: "Offer a mix of free and premium content." },
  ];

  const getImage = (tier?: Tier) => {
    if (tier) {
      if (channelData.subscriptionStatus && channelData.subscriptionStatus === tier) {
        return !disabled ? "/icons/CheckFilled.png" : "/icons/checkeditem.png";
      }
    } else {
      if (!channelData.subscriptionStatus) {
        return !disabled ? "/icons/CheckFilled.png" : "/icons/checkeditem.png";
      }
    }

    return "/icons/CheckInactive.png";
  };

  const handleFileChange = (fileUrl: string | null) => {
    if (fileUrl) {
      updateChannelData && updateChannelData(prev => prev && { ...prev, subscriptionVideoUrl: fileUrl });
    } else {
      const { subscriptionVideoUrl, ...rest } = channelData;
      updateChannelData && updateChannelData(rest);
    }
  };
  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateChannelData && updateChannelData(prev => prev && { ...prev, subscriptionImageUrl: fileUrl ?? undefined });
  };

  return (
    <div>
      {(channelData.subscriptionStatus === Tier.paid || channelData.subscriptionStatus === Tier.freeNpaid) && (
        <div className="flex flex-col mt-[12px] gap-[10px]">
          <div className="flex flex-col gap-[30px]">
            <div className="flex flex-col gap-[10px]">
              <span className="content_title !text-[25px]">Subscription Product IDs</span>
              <div className=" bg-skseparatorgray w-full rounded-full h-[5px]" />
            </div>
            <div className="flex items-center pt-4">
              <AddTextField
                index={1}
                id={"appleMonthlySubscriptionId"}
                name={"appleMonthlySubscriptionId"}
                title={"Apple App Store: Monthly Plan"}
                note={"This is the monthly plan subscription product ID."}
                footNote="Follow this format: com.skarvo.ios.sub.monthly.channelname.0001"
                placeholder={"Enter Monthly Product ID"}
                charAllowed={50}
                value={channelData.appleMonthlySubscriptionId ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { value } = e.target;
                  updateChannelData &&
                    updateChannelData(
                      prev =>
                        prev && {
                          ...prev,
                          appleMonthlySubscriptionId: value,
                        }
                    );
                }}
                showRemainingChar={false}
                disabled={disabled}
              />
            </div>
            {errors.appleMonthlySubscriptionId && <span className="remaining-characters">{errors.appleMonthlySubscriptionId}</span>}
            <div className="flex items-center">
              <AddTextField
                index={2}
                id={"appleYearlySubscriptionId"}
                name={"appleYearlySubscriptionId"}
                title={"Apple App Store: Yearly Plan"}
                note={"This is the yealry plan subscription product ID."}
                footNote="Follow this format: com.skarvo.ios.sub.yearly.channelname.0001"
                placeholder={"Enter Yearly Product ID"}
                charAllowed={50}
                value={channelData.appleYearlySubscriptionId ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { value } = e.target;
                  updateChannelData &&
                    updateChannelData(
                      prev =>
                        prev && {
                          ...prev,
                          appleYearlySubscriptionId: value,
                        }
                    );
                }}
                showRemainingChar={false}
                disabled={disabled}
              />
            </div>
            {errors.appleYearlySubscriptionId && <span className="remaining-characters">{errors.appleYearlySubscriptionId}</span>}

            <div className="flex items-center">
              <AddTextField
                index={3}
                id={"googleSubscriptionGroup"}
                name={"googleSubscriptionGroup"}
                title={"Google Play Store: Subscription Group"}
                note={"This is the subscription group product ID."}
                footNote="Follow this format: com.skarvo.android.sub.channelname"
                placeholder={"Enter Group Product ID"}
                charAllowed={50}
                value={channelData.googleSubscriptionGroup ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { value } = e.target;
                  updateChannelData &&
                    updateChannelData(
                      prev =>
                        prev && {
                          ...prev,
                          googleSubscriptionGroup: value,
                        }
                    );
                }}
                showRemainingChar={false}
                disabled={disabled}
              />
            </div>
            {errors.googleSubscriptionGroup && <span className="remaining-characters">{errors.googleSubscriptionGroup}</span>}

            <div className="flex items-center">
              <AddTextField
                index={4}
                id={"googleMonthlySubscriptionId"}
                name={"googleMonthlySubscriptionId"}
                title={"Google Play Store: Monthly Plan"}
                note={"This is the monthly base plan subscription product ID."}
                footNote="Follow this format: com-skarvo-android-sub-monthly-channelname-0001"
                placeholder={"Enter Monthly Product ID"}
                charAllowed={50}
                value={channelData.googleMonthlySubscriptionId ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { value } = e.target;
                  updateChannelData &&
                    updateChannelData(
                      prev =>
                        prev && {
                          ...prev,
                          googleMonthlySubscriptionId: value,
                        }
                    );
                }}
                showRemainingChar={false}
                disabled={disabled}
              />
            </div>
            {errors.googleMonthlySubscriptionId && <span className="remaining-characters">{errors.googleMonthlySubscriptionId}</span>}

            <div className="flex items-center">
              <AddTextField
                index={5}
                id={"googleYearlySubscriptionId"}
                name={"googleYearlySubscriptionId"}
                title={"Google Play Store: Yearly Plan"}
                note={"This is the yearly base plan subscription product ID."}
                footNote="Follow this format: com-skarvo-android-sub-yearly-channelname-0001"
                placeholder={"Enter Yearly Product ID"}
                charAllowed={50}
                value={channelData.googleYearlySubscriptionId ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { value } = e.target;
                  updateChannelData &&
                    updateChannelData(
                      prev =>
                        prev && {
                          ...prev,
                          googleYearlySubscriptionId: value,
                        }
                    );
                }}
                showRemainingChar={false}
                disabled={disabled}
              />
            </div>
            {errors.googleYearlySubscriptionId && <span className="remaining-characters">{errors.googleYearlySubscriptionId}</span>}
          </div>
        </div>
      )}
    </div>
  );
};
